import React from 'react';
import styled, { css } from 'styled-components';

export function Button({ btnType, label, btnStyle, tBtnType, onClick, ...props }) {
  return (
    <Container
      type="button"
      $btnType={btnType || 'large'}
      $tBtnType={tBtnType}
      $btnStyle={btnStyle}
      onClick={onClick}
      {...props}
    >
      {label}
    </Container>
  );
}

const btnSize = {
  xLarge: css`
    width: 113px;
    height: 46px;
  `,
  large: css`
    width: 109px;
    height: 46px;
  `,
  write: css`
    width: 101px;
    height: 46px;
  `,
  medium: css`
    width: 89px;
    height: 46px;
  `,
  small: css`
    width: 82px;
    height: 33px;
    border: 1px solid rgba(23, 23, 23, 0.12);
  `,
};

const Container = styled.button`
  transition: all 100ms;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ $btnType }) => ($btnType === 'small' && `0.688rem`) || `0.875rem`};
  font-weight: ${({ $btnType }) => ($btnType === 'small' && 500) || 700};
  line-height: 1;
  border-radius: 4px;
  ${({ $btnType }) => btnSize[$btnType]};
  ${({ $btnStyle, theme }) =>
    ($btnStyle === 'fill' &&
      css`
        background-color: ${theme.colors.primary};
        color: white;
      `) ||
    ($btnStyle === 'line' &&
      css`
        background-color: white;
        border: 1px solid ${theme.colors.primary};
        color: ${theme.colors.primary};
      `) ||
    ($btnStyle === 'darkLine' &&
      css`
        background-color: white;
        border: 1px solid ${theme.colors.primary900};
        color: ${theme.colors.primary900};
      `) ||
    ($btnStyle === 'cancel' &&
      css`
        background-color: white;
        border: 1px solid #bebfc01f;
        color: #17171726;
      `)}

  &:hover {
    ${({ $btnStyle, theme }) =>
      ($btnStyle === 'fill' &&
        css`
          background-color: ${theme.colors.primary700};
          color: white;
        `) ||
      ($btnStyle === 'line' &&
        css`
          background-color: white;
          border: 1px solid ${theme.colors.primary700};
          color: ${theme.colors.primary700};
        `) ||
      ($btnStyle === 'darkLine' &&
        css`
          background-color: ${theme.colors.primary900};
          border: 1px solid ${theme.colors.primary900};
          color: white;
        `)}
  }

  @media ${({ theme }) => theme.device.tablet} {
    ${({ $tBtnType }) => btnSize[$tBtnType]};
  }

  @media ${({ theme }) => theme.device.mobile} {
    ${({ $mDisplay }) => $mDisplay && `display:${$mDisplay}`};
    ${({ $mBtnType }) => btnSize[$mBtnType]};
  }
`;
